import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import _getIterator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/get-iterator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import EventBus from "@/utils/eventBus";
import store from "@/store/index";
import * as types from "@/store/constants/types";
import generalUtils from "@/utils/generalUtils";
import { routerStackModule } from "@/utils/routerStackUtil";
/**
 * 通过router钩子在执行前判断:to,from深度，来给予变量值; 钩子执行完后inserted钩子执行函数
 * @param Vue
 * @param router
 * @param options
 */

export function RouterTrasitionPlugin(Vue, router, options) {
  var transitionType;
  var lastPath;
  var staticRouters = [];

  var routerRedirect =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(to, from, next) {
      var lunchData, randomArr, maxRandomNum, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, j, randomNum, findArr, routerName, offerType, offer_map, offerId, face_key;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(to.path === "/home" && from.path === "/")) {
                _context.next = 90;
                break;
              }

              _context.next = 3;
              return store.dispatch(types.GET_LAUNCH_CONFIG);

            case 3:
              lunchData = store.getters[types.GETTER_VIP_PLAN_BY_SOURCE];
              console.log("lunchData setting", lunchData);

              if (generalUtils.isVip()) {
                _context.next = 90;
                break;
              }

              console.log("不是vip需要拦截跳转");

              if (!(lunchData && lunchData.length > 0)) {
                _context.next = 88;
                break;
              }

              randomArr = [];
              maxRandomNum = 0;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 13;

              for (_iterator = _getIterator(lunchData); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                j = _step.value;
                maxRandomNum += j.weight;
                randomArr.push({
                  plan: j.plan,
                  maxWeight: maxRandomNum,
                  freeTrailEnable: j.free_trial_enabled,
                  videoList: j.video_list
                });
              }

              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](13);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 21:
              _context.prev = 21;
              _context.prev = 22;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 24:
              _context.prev = 24;

              if (!_didIteratorError) {
                _context.next = 27;
                break;
              }

              throw _iteratorError;

            case 27:
              return _context.finish(24);

            case 28:
              return _context.finish(21);

            case 29:
              randomNum = Math.random() * maxRandomNum;
              console.log("randomNum", randomNum);
              findArr = randomArr.find(function (item) {
                return item.maxWeight > randomNum;
              });
              console.log("随机到的vip", findArr);
              routerName = "";
              offerType = "";
              _context.t1 = findArr.plan;
              _context.next = _context.t1 === "A" ? 38 : _context.t1 === "B" ? 41 : _context.t1 === "C" ? 44 : _context.t1 === "D" ? 47 : _context.t1 === "E" ? 50 : _context.t1 === "F" ? 53 : _context.t1 === "G" ? 56 : _context.t1 === "H" ? 59 : _context.t1 === "I" ? 62 : _context.t1 === "J" ? 65 : _context.t1 === "K" ? 68 : _context.t1 === "L" ? 71 : _context.t1 === "M" ? 74 : 77;
              break;

            case 38:
              routerName = "vipcenter";
              offerType = "month";
              return _context.abrupt("break", 80);

            case 41:
              routerName = "vipcenter";
              offerType = "week";
              return _context.abrupt("break", 80);

            case 44:
              routerName = "vipcenter";
              offerType = "year";
              return _context.abrupt("break", 80);

            case 47:
              routerName = "vipPage";
              offerType = "week";
              return _context.abrupt("break", 80);

            case 50:
              routerName = "vipPage";
              offerType = "month";
              return _context.abrupt("break", 80);

            case 53:
              routerName = "vipPage";
              offerType = "year";
              return _context.abrupt("break", 80);

            case 56:
              routerName = "vipPlanC";
              offerType = "week";
              return _context.abrupt("break", 80);

            case 59:
              routerName = "vipPlanC";
              offerType = "month";
              return _context.abrupt("break", 80);

            case 62:
              routerName = "vipPlanC";
              offerType = "year";
              return _context.abrupt("break", 80);

            case 65:
              routerName = "vipPlanF";
              offerType = "year";
              return _context.abrupt("break", 80);

            case 68:
              routerName = "vipPlanF";
              offerType = "month";
              return _context.abrupt("break", 80);

            case 71:
              routerName = "vipPlanFnew";
              offerType = "month";
              return _context.abrupt("break", 80);

            case 74:
              routerName = "vipPlanFnew";
              offerType = "year";
              return _context.abrupt("break", 80);

            case 77:
              routerName = "vipcenter";
              offerType = "month";
              return _context.abrupt("return");

            case 80:
              offer_map = store.getters[types.GETTER_OFFER_MAP];
              offerId = _Object$keys(offer_map).find(function (item) {
                return offer_map[item].subscription.period_type.includes(offerType) && offer_map[item].free_slogan.toUpperCase() !== "CONTINUE";
              });
              store.commit(types.UPDATE_OFFER_ID, offerId); //打点的key值

              face_key = "uia_vip_plan_" + findArr.plan.toLowerCase();
              store.commit(types.UPDATE_VIP_ROUTER_DATA, {
                name: routerName,
                query: {
                  type: "single",
                  showToast: true,
                  key: face_key,
                  vipTime: offerType,
                  freeTrailEnable: findArr.freeTrailEnable,
                  videoList: findArr.videoList
                },
                params: {
                  routerTransition: "up"
                }
              });
              next({
                name: routerName,
                query: {
                  type: "single",
                  showToast: true,
                  key: face_key,
                  vipTime: offerType,
                  freeTrailEnable: findArr.freeTrailEnable,
                  videoList: findArr.videoList
                },
                params: {
                  routerTransition: "static"
                }
              });
              _context.next = 90;
              break;

            case 88:
              //没有lunch data，默认进入plan A
              store.commit(types.UPDATE_VIP_ROUTER_DATA, {
                name: "vipcenter",
                query: {
                  type: "single",
                  showToast: true,
                  key: "uia_vip_plan_a" //默认key为plan_a

                },
                params: {
                  routerTransition: "static"
                }
              });
              next({
                name: "vipcenter",
                query: {
                  type: "single",
                  showToast: true,
                  key: "uia_vip_plan_a" //默认key为plan_a

                },
                params: {
                  routerTransition: "static"
                }
              });

            case 90:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[13, 17, 21, 29], [22,, 24, 28]]);
    }));

    return function routerRedirect(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  router.beforeEach(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(to, from, next) {
      var toDepth, fromDepth, transtion, toRouter, fromRouter;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              toDepth = to.path.split("/").length;
              fromDepth = from.path.split("/").length;

              if (to.path.charAt(to.path.length - 1) !== "/") {
                toDepth += 1;
              }

              if (from.path.charAt(from.path.length - 1) !== "/") {
                fromDepth += 1;
              }

              transitionType = toDepth > fromDepth ? "forward" : "back"; //深度相同

              if (toDepth === fromDepth) {
                if (lastPath === to.path) {
                  transitionType = "back";
                } else {
                  transitionType = "forward";
                }

                lastPath = from.path;
              }

              if (to.path && from.path && (!routerStackModule.routerStack[0] || routerStackModule.routerStack[0] && to.name === routerStackModule.routerStack[0].name)) {
                transitionType = "back";
              } //首次进入无效果


              if (to.path === from.path && to.path === lastPath) {
                transitionType = "first";
              } //检测如果instance中包含routerTransitionConfig，则从instace中获取


              if (!to.params.hasOwnProperty("routerTransition")) {
                _context2.next = 13;
                break;
              }

              transitionType = to.params.routerTransition;
              _context2.next = 27;
              break;

            case 13:
              if (!from.params.hasOwnProperty("routerTransition")) {
                _context2.next = 27;
                break;
              }

              //如果当前的路由发现有params transition，则需要相反的方向进行过渡动画
              transtion = from.params.routerTransition;
              _context2.t0 = transtion;
              _context2.next = _context2.t0 === "forward" ? 18 : _context2.t0 === "back" ? 20 : _context2.t0 === "up" ? 22 : _context2.t0 === "down" ? 24 : 26;
              break;

            case 18:
              transitionType = "back";
              return _context2.abrupt("break", 27);

            case 20:
              transitionType = "forward";
              return _context2.abrupt("break", 27);

            case 22:
              transitionType = "down";
              return _context2.abrupt("break", 27);

            case 24:
              transitionType = "up";
              return _context2.abrupt("break", 27);

            case 26:
              return _context2.abrupt("break", 27);

            case 27:
              //如果在规定返回内的路由,来去路由都在规定数组内
              toRouter = staticRouters.find(function (torouter) {
                return torouter.name === to.name;
              });
              fromRouter = staticRouters.find(function (frouter) {
                return frouter.name === from.name;
              });

              if (fromRouter && toRouter) {
                transitionType = "static";
              }

              _context2.next = 32;
              return routerRedirect(to, from, next);

            case 32:
              EventBus.$emit("router-transition-type", transitionType);
              next();
              _context2.next = 40;
              break;

            case 36:
              _context2.prev = 36;
              _context2.t1 = _context2["catch"](0);
              console.warn("router.beforeEach ERROR:", _context2.t1);
              next();

            case 40:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 36]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }());
}